import pluralize from 'pluralize';
const units = new Map([
    ['DAYS', 'day'],
    ['MONTHS', 'month'],
    ['YEARS', 'year']
]);
export function formatMaturity({ duration, unit }) {
    const unitString = units.get(unit);
    return unit ? pluralize(unitString, duration, true) : '';
}
